class TwIntersect {
  constructor() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.remove('intersect')
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.intersect').forEach(el => this.observer.observe(el));
  }
}

export default TwIntersect